"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTableBody = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _RowTableMenu = require("./bodyComponents/RowTableMenu");
var _Images = require("./bodyComponents/Images");
var _ProductStatusWrapper = require("./bodyComponents/ProductStatusWrapper");
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
var _Translations = require("react-platform-components/dist/Translations");
var _tableHooks = require("../tableHooks");
var _TableCellEditable = require("./bodyComponents/TableCellEditable");
var _index = require("../../config/index");
var _excluded = ["products", "filteredHeadColumns"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ReviewsList;
try {
  ReviewsList = require('react-platform-reviewofpurchaseitem/dist/Review/ReviewsList').default;
} catch (error) {}
var StyledTableRow = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover
      }
    }
  };
})(_core.TableRow);
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tableCell: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "200px",
      fontSize: "14px"
    }
  };
});
var CustomTableBody = function CustomTableBody(_ref) {
  var products = _ref.products,
    filteredHeadColumns = _ref.filteredHeadColumns,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedProduct = _useState2[0],
    setSelectedProduct = _useState2[1];
  var _usePopover = (0, _tableHooks.usePopover)(),
    anchorEl = _usePopover.anchorEl,
    open = _usePopover.open,
    handleOpen = _usePopover.handleOpen,
    handleClose = _usePopover.handleClose;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showProductReviews = _useState4[0],
    setShowProductReviews = _useState4[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        user: state.auth.user
      };
    }),
    user = _useSelector.user;
  var handleProductReviewsList = function handleProductReviewsList() {
    dispatch({
      type: 'FETCH_PURCHASE_ITEMS_REVIEWS',
      productId: selectedProduct.id
    });
    setShowProductReviews(true);
  };
  var handleOpenMenu = function handleOpenMenu(product) {
    return function (event) {
      setSelectedProduct(product);
      handleOpen(event);
    };
  };
  var handleCloseMenu = function handleCloseMenu() {
    setSelectedProduct(null);
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement(_core.TableBody, null, products.map(function (product) {
    return /*#__PURE__*/_react.default.createElement(StyledTableRow, {
      key: product.id
    }, filteredHeadColumns.map(function (column) {
      var value = column.value,
        type = column.type,
        specificities = column.specificities,
        editable = column.editable;
      var columnValue = typeof value === 'string' ? (0, _get2.default)(product, value, "") : value(product);
      if (type === "date") {
        return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
          className: classes.tableCell,
          key: value
        }, columnValue.split(" ")[0]);
      } else if (value === "status") {
        return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
          className: classes.tableCell
        }, /*#__PURE__*/_react.default.createElement(_ProductStatusWrapper.ProductStatusWrapper, {
          status: columnValue
        }, product.translated_status));
      } else if (value === "specificity") {
        return specificities.map(function (specificity) {
          var _productSpecificity$c;
          var productSpecificity = product.product_specificities.find(function (product_specificity) {
            return product_specificity.specificity.id === specificity.id;
          }) || {};
          var columnValue = productSpecificity.choice || "";
          if ((_productSpecificity$c = productSpecificity.choices) !== null && _productSpecificity$c !== void 0 && _productSpecificity$c.length) {
            var _productSpecificity$c2;
            columnValue = ((_productSpecificity$c2 = productSpecificity.choices.find(function (choice) {
              return choice.value === columnValue;
            })) === null || _productSpecificity$c2 === void 0 ? void 0 : _productSpecificity$c2.label) || "";
          }
          return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
            className: classes.tableCell,
            key: value,
            title: columnValue
          }, columnValue);
        });
      } else if (value === "images") {
        return /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_Images.Images, {
          key: product.id,
          images: product.images,
          productName: product.name
        }));
      } else {
        return editable ? /*#__PURE__*/_react.default.createElement(_TableCellEditable.TableCellEditable, _extends({
          classes: classes,
          key: value,
          columnValue: columnValue,
          productId: product.id
        }, column)) : /*#__PURE__*/_react.default.createElement(_core.TableCell, {
          className: classes.tableCell,
          key: value,
          title: columnValue
        }, columnValue);
      }
    }), !user.roles.some(function (item) {
      return _index.HIDE_EDIT_PRODUCT_MENU_BY_USER_ROLES.includes(item);
    }) && /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: handleOpenMenu(product)
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "more_vert"))));
  }), selectedProduct && /*#__PURE__*/_react.default.createElement(_RowTableMenu.RowTableMenu, _extends({}, props, {
    open: open,
    anchorEl: anchorEl,
    handleClose: handleCloseMenu,
    product: selectedProduct,
    showReviews: !!ReviewsList,
    handleProductReviewsList: handleProductReviewsList
  })), showProductReviews && /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: showProductReviews,
    onClose: function onClose() {
      return setShowProductReviews(false);
    },
    className: "pb-8",
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    id: "product-reviews"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Product Reviews",
    defaultMessage: "Product Reviews"
  })), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(ReviewsList, null))));
};
exports.CustomTableBody = CustomTableBody;